import { createRootRouteWithContext, Link, Outlet, useLocation } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Button } from "@astryxdesign/core/Button";
import * as stylex from "@stylexjs/stylex";
import { accessAPI, queries, isUnauthorized } from "../lib/api";
import { AppearanceSelect } from "../lib/appearance";
import { styles } from "../lib/styles";
export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  component: Shell
});
function Shell() {
  const location = useLocation();
  const me = useQuery(queries.me());
  const logout = useMutation({
    mutationFn: accessAPI.logout,
    onSuccess: () => {
      window.location.assign("/");
    }
  });
  if (location.pathname === "/approve") return <Outlet />;
  if (me.isPending) return <main {...stylex.props(styles.main)} aria-busy="true">
        Checking your session…
      </main>;
  if (!me.data || isUnauthorized(me.error)) return <div {...stylex.props(styles.loginShell)}>
        <main {...stylex.props(styles.login)}>
          <section {...stylex.props(styles.panel)}>
            <div {...stylex.props(styles.brand, styles.loginBrand)}>
              <img src="/ssbd-logo.png" width="48" height="48" alt="SSBD" />
              <span>
                SSBD Access
                <span {...stylex.props(styles.brandSubtitle)}>Your access workspace</span>
              </span>
            </div>
            <h1 {...stylex.props(styles.title)}>
              Your servers.
              <br />
              Your identity.
            </h1>
            <p {...stylex.props(styles.description)}>
              Sign in with your company account to manage short-lived SSH access. Your private key
              stays on your device.
            </p>
            <div {...stylex.props(styles.actions)}>
              <a href="/auth/login" {...stylex.props(styles.primaryLink)}>
                Sign in with SSB SSO
              </a>
            </div>
          </section>
          <AppearanceSelect />
        </main>
      </div>;
  return <div {...stylex.props(styles.shell)}>
      <header {...stylex.props(styles.header)}>
        <Link to="/" {...stylex.props(styles.brand)}>
          <img src="/ssbd-logo.png" width="44" height="44" alt="" />
          <span>
            SSBD<span {...stylex.props(styles.brandSubtitle)}>Access workspace</span>
          </span>
        </Link>
        <nav aria-label="Main navigation" {...stylex.props(styles.navigation)}>
          {me.data.admin && <>
              <Link to="/" {...stylex.props(styles.navLink)} activeProps={stylex.props(styles.active)} activeOptions={{
            exact: true
          }}>
                Servers
              </Link>
              <Link to="/cloud" {...stylex.props(styles.navLink)} activeProps={stylex.props(styles.active)}>
                Cloud nodes
              </Link>
              <Link to="/rules" {...stylex.props(styles.navLink)} activeProps={stylex.props(styles.active)}>
                Access rules
              </Link>
              <Link to="/recordings" {...stylex.props(styles.navLink)} activeProps={stylex.props(styles.active)}>
                Recordings
              </Link>
              <Link to="/audit" {...stylex.props(styles.navLink)} activeProps={stylex.props(styles.active)}>
                Activity
              </Link>
            </>}
          <Link to="/connect" {...stylex.props(styles.navLink)} activeProps={stylex.props(styles.active)}>
            Connect
          </Link>
        </nav>
        <div {...stylex.props(styles.sidebarFooter)}>
          <AppearanceSelect />
          <span {...stylex.props(styles.identity)}>{me.data.email}</span>
          <Button label="Sign out" xstyle={styles.headerButton} size="sm" onClick={() => logout.mutate()} isLoading={logout.isPending} />
        </div>
      </header>
      <main {...stylex.props(styles.main)}>
        <Outlet />
      </main>
    </div>;
}